module.exports = __webpack_public_path__ + "img/h5-menu.e4e99d88.png";